var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { GET_LIMITS, GetLimitsAction, GetLimitsSuccessAction } from 'app/shared/limits/limits.actions';
import { LimitsService } from 'app/shared/limits/limits.service';
import { BOOTSTRAP_COMPLETE } from 'app/bootstrap/bootstrap.actions';
var LimitsEffects = /** @class */ (function () {
    function LimitsEffects(actions$, limitsService) {
        var _this = this;
        this.actions$ = actions$;
        this.limitsService = limitsService;
        this.fetchLimits$ = this.actions$.pipe(ofType(GET_LIMITS), switchMap(function () { return _this.limitsService.fetchLimits().pipe(map(function (limits) { return new GetLimitsSuccessAction(limits); })); }));
        this.onBootstrapComplete$ = this.actions$.pipe(ofType(BOOTSTRAP_COMPLETE), map(function () { return new GetLimitsAction(); }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], LimitsEffects.prototype, "fetchLimits$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], LimitsEffects.prototype, "onBootstrapComplete$", void 0);
    return LimitsEffects;
}());
export { LimitsEffects };
